import React, { useState } from "react";
import Modal from "react-bootstrap4-modal";

const TermoAceiteModal = ({
  visible,
  titulo,
  conteudo,
  onClose,
  showAcceptButton = true,
  acceptButtonText = "Li e Aceito os Termos",
  acceptButtonDisabled = true,
  onAccept,
  modalClassName = "modal-max-width-75 modal-dialog-tall",
}) => {
  const [showConfirmacao, setShowConfirmacao] = useState(false);

  const handleShowConfirmacao = () => {
    setShowConfirmacao(true);
  };

  const handleCloseConfirmacao = () => {
    setShowConfirmacao(false);
  };

  const handleConfirmarAceite = () => {
    setShowConfirmacao(false);
    if (onAccept) {
      onAccept();
    }
  };

  const handleCloseAll = () => {
    setShowConfirmacao(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Modal Principal do Termo */}
      <Modal visible={visible} dialogClassName={modalClassName}>
        <div className="modal-header" style={{ padding: "10px 10px", position: "relative" }}>
          <div style={{ width: "100%", textAlign: "center" }}>
            <h7 className="modal-title" style={{ fontWeight: "bold" }}>
              {titulo}
            </h7>
          </div>
          <button
            type="button"
            className="close"
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              fontWeight: "700",
              lineHeight: "1",
              color: "#000",
              opacity: "0.5",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            <span>&times;</span>
          </button>
        </div>

        <div className="modal-body" style={{ height: "70vh" }}>
          <div
            className="preview-content p-3"
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              minHeight: "300px",
              maxHeight: "65vh",
              overflow: "auto",
            }}
            dangerouslySetInnerHTML={{ __html: conteudo || "" }}
          ></div>
        </div>

        {showAcceptButton && (
          <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end" }}>
            <button type="button" className="btn btn-success" disabled={acceptButtonDisabled} onClick={handleShowConfirmacao}>
              {acceptButtonText}
            </button>
          </div>
        )}

        {/* Modal de Confirmação - Renderizada dentro da modal principal */}
        {showConfirmacao && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10000,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                maxWidth: "600px",
                width: "90%",
                maxHeight: "80vh",
                overflow: "auto",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  padding: "15px 20px",
                  borderBottom: "1px solid #dee2e6",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ fontWeight: "bold", margin: 0 }}>Confirmação de Aceite</h5>
                <button
                  type="button"
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    lineHeight: "1",
                    color: "#000",
                    opacity: "0.5",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseAll}
                >
                  <span>&times;</span>
                </button>
              </div>

              {/* Body */}
              <div style={{ padding: "20px" }}>
                <p style={{ textAlign: "justify", lineHeight: "1.6", fontSize: "14px", marginBottom: "15px" }}>
                  Ao prosseguir, declaro que li, compreendi e concordo com os termos de utilização, cláusulas padrão e políticas empresarias aplicáveis à utilização do sistema, incluindo normas de
                  conduta, segurança da informação, compliance e demais diretrizes institucionais.
                </p>
                <p style={{ textAlign: "justify", lineHeight: "1.6", fontSize: "14px", marginBottom: 0 }}>
                  Comprometo-me a cumprir as disposições estabelecidas, ciente de que o não atendimento poderá ensejar a aplicação das medidas previstas contratualmente e/ou nos regimentos internos.
                </p>
              </div>

              {/* Footer */}
              <div
                style={{
                  padding: "15px 20px",
                  borderTop: "1px solid #dee2e6",
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <button type="button" className="btn btn-secondary" onClick={handleCloseConfirmacao} style={{ minWidth: "100px" }}>
                  Voltar
                </button>
                <button type="button" className="btn btn-success" onClick={handleConfirmarAceite} style={{ minWidth: "100px" }}>
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default TermoAceiteModal;
